export class InputInfo {
    field;
    value;
    isRequired;
    hasError;

    constructor(field, value, isRequired = false, hasError = false) {
        this.field = field;
        this.value = value;
        this.isRequired = isRequired;
        this.hasError = hasError;
    }
}